import styled from "styled-components";
import propTypes from "prop-types";

const FlexContainer = ({
  className,
  flexDirection,
  flexWrap,
  alignItems,
  alignContent,
  justifyContent,
  gap,
  children,
  ...allProps
}) => {
  return (
    <Container
      className={className}
      flexDirection={flexDirection}
      flexWrap={flexWrap}
      alignItems={alignItems}
      justifyContent={justifyContent}
      alignContent={alignContent}
      gap={gap}
      {...allProps}
    >
      {children}
    </Container>
  );
};

FlexContainer.propTypes = {
  className: propTypes.string,
  flexDirection: propTypes.string,
  flexWrap: propTypes.string,
  alignItems: propTypes.string,
  justifyContent: propTypes.string,
  alignContent: propTypes.string,
  gap: propTypes.number,
};

FlexContainer.defaultProps = {
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "stretch",
  justifyContent: "flex-start",
  alignContent: "normal",
  gap: 0,
};

const Container = styled.div`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection};
  flex-wrap: ${({ flexWrap }) => flexWrap};
  align-items: ${({ alignItems }) => alignItems};
  align-content: ${({ alignContent }) => alignContent};,
  justify-content: ${({ justifyContent }) => justifyContent};
  gap: ${({ gap }) => gap};
`;

export { FlexContainer };
